import { FC } from 'react'
import { useIntl } from 'react-intl'

import { useToken } from '@hooks'
import { ECurrency, isoToECurrency } from '@stores/types/*'
import { localeNumber } from '@utils'
import styled from 'styled-components'

import { DarkBgClass } from '../../../../../generated/quicktype/Tokens'
import { TPaymentGateway } from '../../../../stores/types/TPaymentGatewayState'
import { H4 } from '../../../common/header/Headings'
import { CaptionText500 } from '../../../common/text/BodyText'

const ProviderRateWrapper = styled.div`
  display: flex;
  width: auto;
  align-items: flex-start;
  align-self: stretch;
  margin-left: 16px;
  margin-right: 16px;
`
const ProviderRate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  width: fit-content;
  margin-bottom: 24px;
`
const ProviderRateValue = styled.div`
  align-self: stretch;
  margin-top: 16px;
  font-smooth: never;
`
const ProviderRateCurrency = styled.div<DarkBgClass>`
  align-self: stretch;
  color: ${(bgClass) => bgClass.secondary.default.value};
`
const ProviderCountryIcon = styled.div`
  text-align: right;
  margin-top: 16px;
`

interface ExchangeRateComponentProps {
  paymentGateway: TPaymentGateway
}

export const ExchangeRate: FC<ExchangeRateComponentProps> = (props) => {
  const tokens = useToken()
  const intl = useIntl()

  const currency = isoToECurrency(props.paymentGateway.currencyFrom)
  return (
    <ProviderRateWrapper>
      <ProviderRate>
        <ProviderRateValue data-testid="provider.rate-value">
          <H4>
            {localeNumber(`${props.paymentGateway.exchangeRate}`)}{' '}
            {currency || props.paymentGateway.currencyFrom}
          </H4>
        </ProviderRateValue>
        <ProviderRateCurrency
          {...tokens.color.font.light_bg}
          data-testid="provider.currency"
        >
          {currency == ECurrency.RUB && (
            <CaptionText500>
              {intl.formatMessage({
                id: 'purchaseProviderSelectPage.ruble',
              })}
            </CaptionText500>
          )}
          {currency == ECurrency.UZS && (
            <CaptionText500>
              {intl.formatMessage({
                id: 'purchaseProviderSelectPage.uzs',
              })}
            </CaptionText500>
          )}
          {currency == ECurrency.USD && (
            <CaptionText500>
              {intl.formatMessage({
                id: 'purchaseProviderSelectPage.usd',
              })}
            </CaptionText500>
          )}
          {currency == ECurrency.INR && (
            <CaptionText500>
              {intl.formatMessage({
                id: 'purchaseProviderSelectPage.inr',
              })}
            </CaptionText500>
          )}
          {currency == ECurrency.THB && (
            <CaptionText500>
              {intl.formatMessage({
                id: 'purchaseProviderSelectPage.thb',
              })}
            </CaptionText500>
          )}
          {currency == ECurrency.VND && (
            <CaptionText500>
              {intl.formatMessage({
                id: 'purchaseProviderSelectPage.vnd',
              })}
            </CaptionText500>
          )}
        </ProviderRateCurrency>
      </ProviderRate>
      {currency == ECurrency.RUB && (
        <ProviderCountryIcon>
          <img
            src={'/img/assets/iconRU.svg'}
            width={'32'}
            height={'32'}
            alt={'ru'}
          />
        </ProviderCountryIcon>
      )}
      {currency == ECurrency.UZS && (
        <ProviderCountryIcon>
          <img
            src={'/img/assets/iconUZ.svg'}
            width={'32'}
            height={'32'}
            alt={'uz'}
          />
        </ProviderCountryIcon>
      )}
      {currency == ECurrency.USD && (
        <ProviderCountryIcon>
          <img
            src={'/img/assets/iconUS.svg'}
            width={'32'}
            height={'32'}
            alt={'us'}
          />
        </ProviderCountryIcon>
      )}
      {currency == ECurrency.INR && (
        <ProviderCountryIcon>
          <img
            src={'/img/assets/iconIN.svg'}
            width={'32'}
            height={'32'}
            alt={'in'}
          />
        </ProviderCountryIcon>
      )}
      {currency == ECurrency.THB && (
        <ProviderCountryIcon>
          <img
            src={'/img/assets/iconTH.svg'}
            width={'32'}
            height={'32'}
            alt={'th'}
          />
        </ProviderCountryIcon>
      )}
      {currency == ECurrency.VND && (
        <ProviderCountryIcon>
          <img
            src={'/img/assets/iconVN.svg'}
            width={'32'}
            height={'32'}
            alt={'vn'}
          />
        </ProviderCountryIcon>
      )}
    </ProviderRateWrapper>
  )
}
